export const FIELD_REQUIRED = "Ce champ est obligatoire.";
export const FIELD_NUMBER = "Ce champ doit être un nombre.";
export const FIELD_STRING = 'Ce champ doit être de type "String".';
